"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = exports.useQuery = void 0;
exports.usePollingQuery = usePollingQuery;
var client_1 = require("@apollo/client");
Object.defineProperty(exports, "useQuery", { enumerable: true, get: function () { return client_1.useQuery; } });
Object.defineProperty(exports, "useMutation", { enumerable: true, get: function () { return client_1.useMutation; } });
var app_utils_1 = require("@sixfold/app-utils");
var typed_primitives_1 = require("@sixfold/typed-primitives");
var React = __importStar(require("react"));
var DEFAULT_FETCH_POLICY = 'cache-first';
var correctLoadingFlag = function (loading, variables, state) {
    if (!loading) {
        return false;
    }
    // We have multiple situations in which we do not want to report ourselves as loading
    // ...during refetch (the easiest polling scenario)
    if (state.networkStatus === client_1.NetworkStatus.refetch) {
        return false;
    }
    // ...during fetchMore (pagination)
    if (state.networkStatus === client_1.NetworkStatus.fetchMore) {
        return false;
    }
    // ...during setVariables when the variables are not actually different from what we have in state
    if (state.networkStatus === client_1.NetworkStatus.setVariables && (0, typed_primitives_1.deepEqual)(variables, state.variables)) {
        return false;
    }
    // ...during loading state when the request is asked to be skipped and variables are the same
    if (state.networkStatus === client_1.NetworkStatus.loading && state.skip && (0, typed_primitives_1.deepEqual)(variables, state.variables)) {
        return false;
    }
    // ...during loading state when we have data, and the variables are the same
    if (state.networkStatus === client_1.NetworkStatus.loading &&
        state.data !== undefined &&
        (0, typed_primitives_1.deepEqual)(variables, state.variables)) {
        return false;
    }
    return true;
};
var shouldUpdateState = function (result, state) {
    // When we transition into ready state
    if (result.networkStatus === client_1.NetworkStatus.ready && state.networkStatus !== client_1.NetworkStatus.ready) {
        return true;
    }
    // When we are in ready state and data changes (unless it goes to undefined and we are skipping)
    if (result.networkStatus === client_1.NetworkStatus.ready && !(0, typed_primitives_1.deepEqual)(result.data, state.data)) {
        if (result.data === undefined && state.skip) {
            return false;
        }
        return true;
    }
    // By default we do not update state
    return false;
};
function usePollingQuery(query, options) {
    var _this = this;
    var _a, _b, _c;
    var client = (0, client_1.useApolloClient)();
    var defaultFetchPolicy = (_b = (_a = client.defaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) !== null && _b !== void 0 ? _b : DEFAULT_FETCH_POLICY;
    var pollInterval = options.pollInterval, _d = options.idleUserPollIntervalMultiplier, idleUserPollIntervalMultiplier = _d === void 0 ? 10 : _d, calculateVariables = options.calculateVariables, propVariables = options.variables, skip = options.skip, rest = __rest(options, ["pollInterval", "idleUserPollIntervalMultiplier", "calculateVariables", "variables", "skip"]);
    var deriveVariables = function (data) { var _a; return (_a = calculateVariables === null || calculateVariables === void 0 ? void 0 : calculateVariables(data)) !== null && _a !== void 0 ? _a : propVariables; };
    var state = React.useRef({
        data: undefined,
        variables: deriveVariables(),
        networkStatus: client_1.NetworkStatus.error,
        skip: false,
    });
    var variables = deriveVariables(state.current.data);
    var onError = (0, app_utils_1.useErrorHandler)();
    var result = (0, client_1.useQuery)(query, __assign(__assign({}, rest), { 
        // We want to avoid using cache-and-network, even if that is configured as the default on the client
        fetchPolicy: (_c = rest.fetchPolicy) !== null && _c !== void 0 ? _c : (defaultFetchPolicy === 'cache-and-network' ? DEFAULT_FETCH_POLICY : defaultFetchPolicy), notifyOnNetworkStatusChange: true, skip: skip, variables: variables, returnPartialData: false }));
    (0, app_utils_1.useActiveUserInterval)(function () { return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (result.networkStatus !== client_1.NetworkStatus.ready) {
                        // Skip poll if some other process is ongoing (pagination, some long running poll etc.)
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, result.refetch(deriveVariables(state.current.data))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (e_1 instanceof Error) {
                        onError === null || onError === void 0 ? void 0 : onError.captureError(e_1);
                    }
                    else {
                        onError === null || onError === void 0 ? void 0 : onError.captureError(new typed_primitives_1.NestedError('Unknown error', e_1));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, {
        activeInterval: pollInterval,
        idleInterval: idleUserPollIntervalMultiplier * pollInterval,
    });
    if (skip === true) {
        state.current.skip = true;
    }
    if (shouldUpdateState(result, state.current)) {
        state.current.data = result.data;
        state.current.variables = deriveVariables(state.current.data);
    }
    if (state.current.networkStatus === client_1.NetworkStatus.ready) {
        state.current.skip = false;
    }
    state.current.networkStatus = result.networkStatus;
    var loading = correctLoadingFlag(result.loading, variables, state.current);
    return __assign(__assign({}, result), { loading: loading, data: state.current.data });
}
//# sourceMappingURL=hooks.js.map